import classNames from 'classnames';
import PropTypes from 'prop-types';

const SmartTvIcon = ({ className, width = '24' }) => {
  return (
    <svg
      className={classNames('smart-tv-icon', className)}
      width={width}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M1.25 2.5C1.25 2.08579 1.58579 1.75 2 1.75H22C22.4142 1.75 22.75 2.08579 22.75 2.5V18.5C22.75 18.9142 22.4142 19.25 22 19.25H19.159L19.9481 21.6174L18.0508 22.2499L17.0508 19.25H6.94811L5.94815 22.2499L4.05078 21.6174L4.83992 19.25H2C1.58579 19.25 1.25 18.9142 1.25 18.5V2.5ZM11.25 15C11.25 10.9959 14.4959 7.75 18.5 7.75V6.25C13.6675 6.25 9.75 10.1675 9.75 15H11.25ZM14.45 15C14.45 12.7632 16.2632 10.95 18.5 10.95V9.45C15.4348 9.45 12.95 11.9348 12.95 15H14.45ZM17.65 15C17.65 14.5306 18.0306 14.15 18.5 14.15V12.65C17.2021 12.65 16.15 13.7021 16.15 15H17.65Z'
        fill='currentColor'
      />
    </svg>
  );
};

SmartTvIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
};

export default SmartTvIcon;
